import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import styles from "./styles";

import { Paper, withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { hoverPoi } from "../../store/district";

const Results = ({ data, classes }) => {
	const dispatch = useDispatch();
	const { hoverId } = useSelector(state => state.district);
	const [hoveredPoi, setHoverPoi] = useState(hoverId);
	useEffect(() => {
		setHoverPoi(hoverId);
	}, [hoverId]);
	return (
		<Link className={classes.poiList} to={`/district/${data.id}`}>
			<Paper
				onMouseEnter={() => dispatch(hoverPoi(data.id))}
				onMouseLeave={() => dispatch(hoverPoi(null))}
				className={`${classes.paper} ${hoveredPoi === data.id && "active-poi"}`}
			>
				{data.title}
			</Paper>
		</Link>
	);
};

export default withStyles(styles)(Results);
